import { skeletonize } from "../../helpers/skeletonize";
import { Body } from "../body/Body";
import { IconButton } from "../icon-button/IconButton.Parts";
import { SkeletonProps } from "./Select.Parts";
import {
  Button,
  Placeholder,
  ToggleButtonContainer,
} from "./trigger/Trigger.Parts";

const SelectButtonSkeleton = skeletonize(Button);
const MultiSelectPlaceholderSkeleton = skeletonize(Placeholder);
const ChevronSkeleton = skeletonize(IconButton);
const BodySkeleton = skeletonize(Body);

export const SelectSkeleton = ({
  placeholder,
  multi,
  rows = 1,
  width,
}: SkeletonProps) => (
  <SelectButtonSkeleton $multi={multi} $rows={rows} $width={width}>
    {multi ? (
      <>
        <MultiSelectPlaceholderSkeleton>
          {placeholder}
        </MultiSelectPlaceholderSkeleton>
        <ToggleButtonContainer>
          <ChevronSkeleton $small />
        </ToggleButtonContainer>
      </>
    ) : (
      <>
        <BodySkeleton>{placeholder}</BodySkeleton>
        <ChevronSkeleton $small />
      </>
    )}
  </SelectButtonSkeleton>
);
